import { rem } from "./index.js";
export var borderRadius = {
    none: rem(0),
    sm: rem(4),
    md: rem(8),
    lg: rem(12),
    xl: rem(16),
    "2xl": rem(24),
    "3xl": rem(32),
    full: rem(9999)
};

//# sourceMappingURL=borderRadius.js.map